import React from 'react';
import DateUtility from './lib/dateUtility';
import { ReactRenderer } from './lib/ReactRenderer';
import ShiftExchangeComponent from './ShiftExchangeComponent';
import { udbydSummary } from './lib/swapShiftLine';
import { MoreButton, parseAsSection, parseVisibleCount, RoleLabel, SectionHead, ShiftList, ShiftPageHead, ShiftRow, SwapPill } from './lib/shiftList';
const RsvpDot = ({ rsvp }) => {
    const title = rsvp === 1 ? "Kommer" : rsvp === 2 ? "Kommer ikke" : "Ikke svaret";
    const kind = rsvp === 1 ? "yes" : rsvp === 2 ? "no" : "none";
    return React.createElement("span", { className: `bi-rsvp bi-rsvp-${kind}`, role: "img", "aria-label": title, title: title });
};
/** One person on the shift: the role as an icon, the answer to the RSVP for the kiosk, the name on one line. */
const Person = ({ member, memberUdi }) => {
    const isOperator = member.role === "Operator";
    const label = isOperator ? "Operatør" : "Kiosk";
    return (React.createElement("div", { className: `bi-next-person${member.memberId === memberUdi ? " bi-next-person-me" : ""}` },
        React.createElement("span", { className: "bi-next-person-role", role: "img", "aria-label": label, title: label },
            React.createElement(RoleLabel, { role: member.role, iconOnly: true })),
        isOperator ? React.createElement("span", { className: "bi-next-person-slot" }) : React.createElement(RsvpDot, { rsvp: member.rsvp }),
        React.createElement("span", { className: "bi-next-person-name" }, member.name || "Ikke besat")));
};
/** "Din næste vagt": the date, the shows, who is on, and the two things a volunteer does about it. */
const NextShift = ({ shift, memberUdi }) => {
    const start = DateUtility.parse(shift.dtStart);
    const end = DateUtility.parse(shift.dtEnd);
    const me = shift.members.find((m) => m.memberId === memberUdi);
    const operator = shift.members.find((m) => m.role === "Operator");
    const shops = shift.members.filter((m) => m.role !== "Operator");
    const planned = shift.status === 2;
    return (React.createElement("section", { className: "bi-sl-section bi-next" },
        React.createElement(SectionHead, { title: "Din n\u00E6ste vagt" }),
        React.createElement("div", { className: "bi-next-card" },
            React.createElement("div", { className: "bi-next-top" },
                React.createElement("div", { className: "bi-next-tile", "aria-hidden": "true" },
                    React.createElement("span", null, DateUtility.weekdayShort(start).toUpperCase()),
                    React.createElement("strong", null, start.day),
                    React.createElement("span", null, DateUtility.monthShort(start))),
                React.createElement("div", { className: "bi-next-when" },
                    React.createElement("div", { className: "bi-next-interval" }, DateUtility.rowInterval(start, end)),
                    React.createElement("div", { className: "bi-next-chips" },
                        me ? React.createElement("span", { className: "bi-chip bi-chip-role" },
                            React.createElement(RoleLabel, { role: me.role })) : null,
                        (me === null || me === void 0 ? void 0 : me.shiftExchange)
                            ? React.createElement("span", { className: "bi-chip" }, "Sat til bytte")
                            : React.createElement("span", { className: `bi-chip ${planned ? "bi-chip-planned" : "bi-chip-preplanned"}` },
                                React.createElement("span", { className: `bi-sr-dot ${planned ? "bi-sr-dot-planned" : "bi-sr-dot-preplanned"}` }),
                                planned ? "Planlagt" : "Foreløbig")))),
            React.createElement("div", { className: "bi-next-films" }, shift.events.length === 0
                ? React.createElement("div", { className: "bi-next-film" },
                    React.createElement("span", { className: "bi-next-film-title" }, "Ingen planlagte film"))
                : shift.events.map((evt, idx) => {
                    var _a;
                    return (React.createElement("div", { className: "bi-next-film", key: idx },
                        React.createElement("span", { className: "bi-next-film-time" }, DateUtility.parse(evt.startTime).toFormat("HH:mm")),
                        React.createElement("span", { className: "bi-next-film-title" }, evt.eventContent.title),
                        React.createElement("span", { className: "bi-next-film-venue" }, (_a = evt.venue) === null || _a === void 0 ? void 0 : _a.venueName)));
                })),
            React.createElement("div", { className: "bi-next-crew" },
                operator ? React.createElement(Person, { member: operator, memberUdi: memberUdi }) : null,
                shops.map((m, idx) => React.createElement(Person, { key: idx, member: m, memberUdi: memberUdi }))),
            React.createElement("div", { className: "bi-next-actions" },
                React.createElement("a", { className: "bi-btn bi-btn-primary", href: `/vagtinfo?shiftId=${shift.id}` }, "Se vagten"),
                me
                    ? React.createElement("div", { className: "bi-next-swap" },
                        React.createElement(ShiftExchangeComponent, Object.assign({ shiftexchange: me.shiftExchange, shiftid: shift.id, variant: "front" }, udbydSummary(shift, me.role))))
                    : null))));
};
class ShiftScheduleComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            visible: parseVisibleCount(this.props.visiblecount)
        };
    }
    componentDidMount() {
        fetch(`/bpapi/shiftschedule/memberschedule`, { method: 'GET' })
            .then((response) => {
            if (response.ok) {
                return response.json();
            }
            else {
                return Promise.reject(`Der opstod en fejl (${response.status} ${response.statusText})`);
            }
        })
            .then((result) => {
            this.setState({ isLoaded: true, schedule: result });
        })
            .catch(error => this.setState({ isLoaded: true, error: error }));
    }
    row(item, memberUdi) {
        const member = item.members.find((m) => m.memberId === memberUdi);
        return (React.createElement(ShiftRow, { list: "min", href: `/vagtinfo?shiftId=${item.id}`, start: DateUtility.parse(item.dtStart), end: DateUtility.parse(item.dtEnd), events: item.events, status: item.status === 2 ? "planned" : "pre", context: React.createElement(React.Fragment, null,
                React.createElement(RoleLabel, { role: member === null || member === void 0 ? void 0 : member.role }),
                (member === null || member === void 0 ? void 0 : member.shiftExchange) ? React.createElement(SwapPill, null) : null) }));
    }
    render() {
        if (!this.state.isLoaded) {
            return (React.createElement("p", { className: "card-text" }, "Vagtplanen indl\u00E6ses."));
        }
        if (this.state.error) {
            return (React.createElement("p", { className: "card-text" }, this.state.error));
        }
        const shifts = this.state.schedule.shifts;
        const memberUdi = this.state.schedule.memberUdi;
        // The number of shifts limits the list (and "Vis flere" adds that many); zero shows it all.
        const limit = parseVisibleCount(this.props.visiblecount);
        const more = (shown, total) => limit > 0 && shown < total
            ? React.createElement(MoreButton, { onClick: () => this.setState({ visible: this.state.visible + limit }) })
            : null;
        // As a section (the front page): the next shift as a card, and the ones after it as a list.
        if (parseAsSection(this.props.assection)) {
            if (shifts.length < 1) {
                return (React.createElement("section", { className: "bi-sl-section" },
                    React.createElement(SectionHead, { title: "Din n\u00E6ste vagt" }),
                    React.createElement("p", { className: "bi-sl-empty bi-sl-empty-card" }, "Der er ingen kommende vagter i vagtplanen.")));
            }
            const later = shifts.slice(1);
            const upcoming = limit > 0 ? later.slice(0, this.state.visible) : later;
            return (React.createElement(React.Fragment, null,
                React.createElement(NextShift, { shift: shifts[0], memberUdi: memberUdi }),
                upcoming.length > 0
                    ? React.createElement("section", { className: "bi-sl-section" },
                        React.createElement(SectionHead, { title: "Kommende vagter", count: later.length, href: "/min-side/min-vagtplan" }),
                        React.createElement("div", { className: "bi-sl-card" },
                            React.createElement(ShiftList, { list: "min", items: upcoming, start: (item) => DateUtility.parse(item.dtStart), columns: [], footer: more(upcoming.length, later.length), renderRow: (item) => this.row(item, memberUdi) })))
                    : null));
        }
        return (React.createElement("div", { className: "bi-sl-page" },
            React.createElement(ShiftPageHead, { title: "Min vagtplan", subtitle: "Dine kommende vagter." }),
            shifts.length < 1
                ? React.createElement("p", { className: "bi-sl-empty" }, "Der er ingen kommende vagter i vagtplanen.")
                : React.createElement(ShiftList, { list: "min", items: limit > 0 ? shifts.slice(0, this.state.visible) : shifts, start: (item) => DateUtility.parse(item.dtStart), columns: ["Vagt", "", "Rolle", "Film", ""], footer: more(Math.min(this.state.visible, shifts.length), shifts.length), renderRow: (item) => this.row(item, memberUdi) })));
    }
}
ReactRenderer.render("shiftschedulecomponent", (elem) => React.createElement(ShiftScheduleComponent, Object.assign({}, (elem.dataset))));
